import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './EditSelectedTemplate.scss';
import { HeaderPageMessage, ModalPdf } from 'components';
import { useParams, useNavigate } from 'react-router-dom';
import { Col, Input, Button, Image, Form } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import {
  getParametrosPlantillas,
  getPlantillas,
  guardarParametroPlantilla
} from 'actions/templates.actions';
import { selectTemplateParamsState, selectTemplatesState } from 'selectors/templates.selector';
import InfoModal from 'components/InfoModal/InfoModal';
import { EDICION_PLANTILLAS_ROUTE } from 'constants/routeNames';
import { convertirTipoPlantillaTipoMonitoreo } from 'utils/convertirTipoPlantillaTipoMonitoreo';
import { getPdfActa } from 'actions/pdf.actions';
import { compareArrays } from 'utils/compareArrays';
import message from 'components/Message/Message';
import { MONITOREOS_INTERNET, MONITOREOS_MEDIOS_IMPRESOS } from 'constants/tipoMonitoreos';
import { PDF_INTERNET, PDF_MEDIOS_IMPRESOS } from 'constants/pdfTypes';
import dayjs from 'dayjs';
import { REGULAR_DATE_FORMAT } from 'constants/dateFormat';
import ConfirmationModal from './components/ConfirmationModal';
import ParametersList from './components/ParametersList';
import ConfirmationInfoModal from './components/ConfirmationInfoModal/ConfirmationInfoModal';

const { TextArea } = Input;

const EditTemplate = () => {
  const { idPlantilla } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [plantillaSeleccionada, setPlantillaSeleccionada] = useState(null);
  const [valor, setValor] = useState('');
  const [variablesEncontradas, setVariablesEncontradas] = useState([]);
  const [maxLengthAreaText, setMaxLengthAreaText] = useState(1200);
  const [eventValue, setEventValue] = useState('');
  const [isModalPDFOpen, setIsModalPDFOpen] = useState(false);
  const [pdfActa, setPdfActa] = useState(null);
  const [tipoActa, setTipoActa] = useState(null);
  const [idParametro, setIdParametro] = useState(null);
  const [ejemplo, setEjemplo] = useState(null);
  const [storageSelectedSeccion, setStorageSelectedSeccion] = useState({});
  const [idParametroStorage, setIdParametroStorage] = useState(null);
  const [isVisibleSuccesModal, setIsVisibleSuccessModal] = useState(false);
  const [isVisibleConfirmModal, setIsVisibleConfirmModal] = useState(false);
  const [isVisibleConfirmInfoModal, setIsVisibleConfirmInfoModal] = useState(false);
  const [dataPlantillaSelected, setDataPlantillaSelected] = useState([]);

  const { data: dataPlantillas } = useSelector(selectTemplatesState);
  const { loading, data } = useSelector(selectTemplateParamsState);

  const obtenerPlantilla = () => {
    setPlantillaSeleccionada(
      dataPlantillas?.find((plantilla) => plantilla.idPlantilla === Number(idPlantilla))
    );
  };

  const dispatch = useDispatch();

  const findPattern = (str) => {
    const regex = /\$P\{[^}]+\}/g;
    const matches = [];
    let match = regex.exec(str);

    while (match !== null) {
      matches.push(match[0]);
      match = regex.exec(str);
    }

    return matches;
  };

  const validateVariablesValues = (arrayVariables) => (_, value) => {
    if (!compareArrays(arrayVariables, findPattern(value)))
      return Promise.reject(
        Error(`Revisa que se encuentren todas las variables: ${arrayVariables.toString()}`)
      );
    return Promise.resolve();
  };

  const obtainTipoActa = (tipoActaTipoMonitoreo) => {
    switch (tipoActaTipoMonitoreo.tipoMonitoreo) {
      case MONITOREOS_INTERNET:
        return PDF_INTERNET;
      case MONITOREOS_MEDIOS_IMPRESOS:
        return PDF_MEDIOS_IMPRESOS;
      default:
        return tipoActaTipoMonitoreo.tipoActa;
    }
  };

  const onChangeTextArea = ({ target }) => {
    const { value } = target;
    setEventValue(value);
  };

  const handleGetStorageSeccion = () => {
    if (storageSelectedSeccion?.idParametro !== 0) {
      setIdParametro(storageSelectedSeccion.idParametro);
      setEjemplo(storageSelectedSeccion.ejemplo);
      setValor(storageSelectedSeccion.valor);
      setEventValue('');
      setIdParametroStorage(storageSelectedSeccion.idParametro);
      setIsVisibleConfirmInfoModal(false);
    }
  };

  const handleGetPdfActa = async () => {
    const payload = convertirTipoPlantillaTipoMonitoreo(plantillaSeleccionada.idPlantilla);
    payload.tipoDescarga = 1;
    payload.listaIdMonitoreos = [];
    payload.ejemploPDF = 1;
    try {
      const { success, response } = await dispatch(getPdfActa(payload));

      const { archivo } = response.data;
      if (success) {
        setPdfActa(archivo);
        setTipoActa(obtainTipoActa(payload));
        setIsModalPDFOpen(true);
      }
    } catch (error) {
      message.error('Error al obtener el PDF', 3);
    }
  };

  const handleValidateSaveParameter = async () => {
    try {
      await form.validateFields();
      setIsVisibleConfirmModal(true);
    } catch (error) {
      const { errorFields } = error;
      if (errorFields) {
        console.log(errorFields);
      }
    }
  };

  const handleSaveParameter = async () => {
    const parametroAGuardar = {
      toUpdate: [
        { idParametro, valor: form.getFieldValue('valor'), idPlantilla: Number(idPlantilla) }
      ]
    };
    const { success } = await dispatch(guardarParametroPlantilla(parametroAGuardar));
    if (success) {
      const seccionModified = data.find(
        (seccionSelected) => seccionSelected.idParametro === idParametro
      );
      const updatedDataSeccion = {
        ...seccionModified,
        valor: form.getFieldValue('valor')
      };
      const updatedDataSeccionList = [...data];
      const indexToUpdated = updatedDataSeccionList.findIndex(
        (s) => s.idParametro === updatedDataSeccion.idParametro
      );
      updatedDataSeccionList[indexToUpdated] = updatedDataSeccion;
      setDataPlantillaSelected(updatedDataSeccionList);
      setIsVisibleSuccessModal(true);
      setEventValue('');
    }
  };

  const handleCancel = () => {
    navigate(EDICION_PLANTILLAS_ROUTE);
  };

  useEffect(() => {
    form.setFieldsValue({ valor });
    setVariablesEncontradas(findPattern(valor));
    // Se evalúa que si la longitud es mayor a 1200(proto) se adapte
    if (valor.length > 1200) {
      setMaxLengthAreaText(valor.length + 10);
      return;
    }
    setMaxLengthAreaText(1200);
  }, [valor]);

  useEffect(() => {
    if (!dataPlantillas.length) {
      dispatch(getPlantillas());
    }
    dispatch(getParametrosPlantillas({ idPlantilla }));
  }, []);

  useEffect(() => {
    setDataPlantillaSelected(data);
  }, [data]);

  useEffect(() => {
    obtenerPlantilla();
  }, [dataPlantillas]);

  useEffect(() => {
    return form.setFieldsValue({ valor });
  }, [valor]);

  return (
    <div className="edicion-plantilla-seleccionada">
      <div className="container-headerPage">
        <div className="header-page">
          <Col span={18}>
            <HeaderPageMessage
              title="Edición de plantillas"
              section="Gestión de contenido"
              message="Al guardar los cambios, no se recuperará la versión anterior"
            />
          </Col>
        </div>
        <h1 className="title-label">Plantilla: {plantillaSeleccionada?.nombre}</h1>
        <span className="header-label">Selecciona la sección que deseas modificar.</span>
      </div>
      {isModalPDFOpen && (
        <ModalPdf
          open={isModalPDFOpen}
          ultimaActualizacion={dayjs(plantillaSeleccionada.fecha_hora).format(REGULAR_DATE_FORMAT)}
          usuario={plantillaSeleccionada.usuario}
          titulo={plantillaSeleccionada.nombre}
          pdfActa={pdfActa}
          tipoActa={tipoActa}
          callback={() => setIsModalPDFOpen(false)}
          destroyOnClose
        />
      )}
      <InfoModal
        description="Plantilla guardada exitosamente"
        visible={isVisibleSuccesModal}
        onClose={() => setIsVisibleSuccessModal(false)}
      />
      <ConfirmationModal
        visible={isVisibleConfirmModal}
        onClose={() => setIsVisibleConfirmModal(false)}
        handleSaveParameter={handleSaveParameter}
      />
      <ConfirmationInfoModal
        visible={isVisibleConfirmInfoModal}
        onClose={() => setIsVisibleConfirmInfoModal(false)}
        onAccept={() => handleGetStorageSeccion()}
      />
      <div className="container-template-page">
        <ParametersList
          data={dataPlantillaSelected}
          loading={loading}
          setValor={setValor}
          setIdParametro={setIdParametro}
          setEjemplo={setEjemplo}
          setStorageSelectedSeccion={setStorageSelectedSeccion}
          updateValue={eventValue}
          setEventValue={setEventValue}
          setIsVisibleConfirmInfoModal={setIsVisibleConfirmInfoModal}
          idParametroStorage={idParametroStorage}
          setIdParametroStorage={setIdParametroStorage}
        />
        <div className="container-text-area">
          <div>
            <div className="container-button-visualizar">
              <Button
                type="text"
                onClick={() => handleGetPdfActa()}
                icon={<EyeOutlined />}
                iconPosition="start">
                Visualizar plantilla
              </Button>
            </div>
            <Form form={form}>
              <Form.Item
                name="valor"
                rules={[
                  {
                    validator: validateVariablesValues(variablesEncontradas)
                  }
                ]}>
                <TextArea
                  onChange={(e) => onChangeTextArea(e)}
                  showCount
                  maxLength={maxLengthAreaText}
                  style={{ height: '180px' }}
                />
              </Form.Item>
            </Form>
          </div>
          <div className="container-button-save-cancel">
            <Button
              type="primary"
              onClick={() => handleCancel()}
              ghost
              style={{ marginRight: '15px' }}>
              Cancelar
            </Button>
            <Button type="primary" onClick={handleValidateSaveParameter}>
              Guardar
            </Button>
          </div>
        </div>
        <Image
          width={200}
          visible={false}
          src={
            ejemplo !== undefined && ejemplo !== null
              ? `data:image/svg+xml;base64,${ejemplo}`
              : null
          }
          preview={false}
        />
      </div>
    </div>
  );
};

EditTemplate.propTypes = {};

export default EditTemplate;
